//** Gestion des valeurs inputs et checkboxs */
export const handleChange = (event, setFormData, formData) => {
    const { name, value } = event.target;
    setFormData((values) => ({ ...values, [name]: value }));
    if (
      event.target.classList.contains("radio-group") ||
      event.target.classList.contains("select-group")
    ) {
      document
        .querySelectorAll(
          "." + event.target.getAttribute("datagroup") + "-group"
        )
        .forEach((element) => {
          formData[element.name] = "";
          delete formData[element.name];
          element.classList.replace("is-invalid", "is-valid");
        });
    }
};

export const handleTrimValue = (event, setFormData) => {
  const { name, value } = event.target;
  setFormData((values) => ({ ...values, [name]: value.trim() }));
};

//** Permet de checker la confirmation d'email */
export const handleChangeMandataireConfirm = (event, setFormData, formData) => {
  const { name, value } = event.target;
  setFormData((values) => ({ ...values, [name]: value }));
  if (event.target.value !== formData.MandataireEmail) {
    document
      .querySelector(".confirmMandataireEmail")
      .classList.add("is-invalid");
  }
};

export const handleChangeMandantConfirm = (event, formData, setFormData) => {
  const confirmMandantEmail_P = document.querySelector(
    ".confirmMandantEmail_P"
  );
  const confirmMandantEmail_M = document.querySelector(
    ".confirmMandantEmail_M"
  );
  if (event.target.value !== formData.MandantEmail) {
    if(confirmMandantEmail_P)confirmMandantEmail_P.classList.add("is-invalid");
  }
  if (event.target.value !== formData.MandantEmail) {
    if(confirmMandantEmail_M)confirmMandantEmail_M.classList.add("is-invalid");
  }
  const { name, value } = event.target;
  setFormData((values) => ({ ...values, [name]: value }));
};

//** Fonction permettant de supprimer la class "is-invalid" lorsqu'un input required est rempli */
export const inputFocus = (page) => {
  const inputs = document.querySelectorAll(".page-" + page + "-required");
  const inputsPro = document.querySelectorAll(".error");

  inputs.forEach((element) => {
    if (element.value !== "" || element.checked === true) {
      element.classList.replace("is-invalid", "is-valid");
    }
  });
  inputsPro.forEach((element) => {
    if (element.value !== "") {
      element.classList.replace("is-invalid", "is-valid");
    }
  });
};

//** Fonctions permettant de gérer l'ajout et la suppression des pièces jointes */
export const handleChangeFiles = (event, x_id_submit, TypeForm, ville, filesTest, formData, setFormData, getBase64, fetchURL, setLoading, toast) => {
  let res = {};
  setLoading(true);
  res["x-id-submit"] = x_id_submit;
  res["TypeForm"] = TypeForm;
  res["ImmLocaliteAdr"] = ville;
  res["reinitJustif"] = 0;
  res["name"] = event.target.files[0].name;
  res["RGPD_OK"] = 1;
  let selectedFile = event.target.files[0];
  const maxSize = 8 * 1024 * 1024;

  if (selectedFile.size > maxSize) {
    if (document.getElementById("input-file-" + event.target.name)) {
      document.getElementById("input-file-" + event.target.name).innerHTML =
        "";
      document
        .getElementById("file-size-alert_" + event.target.name)
        .classList.replace("d-none", "d-block");
    }
    event.target.value = null;
    setLoading(false);
  } else {
    if (document.getElementById("file-size-alert_" + event.target.name)) {
      document
        .getElementById("file-size-alert_" + event.target.name)
        .classList.add("d-none");
    }
    filesTest = true;
    getBase64(selectedFile).then((data) => {
      res[event.target.name] = [data];
      let myHeaders = {
        "Content-Type": "application/json",
      };
      console.log(res);
      let myInit = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(res),
        mode: "cors",
        cache: "default",
      };
      console.log(myInit);
      fetch(fetchURL.path_justifs, myInit)
        .then((response) => {
          let result = response.json();
          return result;
        })
        .then((result) => {
          console.log(result);
          if (result.code === 200) {
            formData.files[event.target.name].push(selectedFile.name);
            setFormData((values) => ({ ...values, files: formData.files }));
          }
          setLoading(false);
        })
        .catch((reason) => {
          console.log(reason);
          toast.error(
            "Une erreur est survenue lors de l'envoi du fichier. Veuillez réessayer ultérieurement ou contacter le support si le problème persiste."
          );
          setLoading(false);
        });
    });
  }
};

//** Fonction permettant de réinitialiser les pièces jointes d'un seul input */
export const handleResetInputFiles = (event, x_id_submit, TypeForm, ville, fetchURL, formData, setFormData) => {
  let res = {};
  res["x-id-submit"] = x_id_submit;
  res["TypeForm"] = TypeForm;
  res["ImmLocaliteAdr"] = ville;
  res["reinitJustif"] = 1;
  res["filesDirection"] = event.target.id;
  let myHeaders = {
    "Content-Type": "application/json",
  };
  console.log(res);
  let myInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(res),
    mode: "cors",
    cache: "default",
  };
  fetch(fetchURL.path_justifs, myInit)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      console.log(result);
    })
    .catch((reason) => {
      console.log(reason);
    });
  if (event && event.target) {
    const name = event.target.name;
    const updateFiles = { ...formData.files };
    updateFiles[name] = [];
    document.getElementById("input-file-" + event.target.name).value = "";
    setFormData({ ...formData, files: updateFiles });
  }
  const inputs = document.querySelectorAll(".inputLiberale");
  inputs.forEach((input) => {
    input.setAttribute("required", true);
  });
};

export const handleResetFiles = (x_id_submit, TypeForm, ville, fetchURL, files, setFormData, formData) => {
  let res = {};
  res["x-id-submit"] = x_id_submit;
  res["TypeForm"] = TypeForm;
  res["ImmLocaliteAdr"] = ville;
  res["reinitJustif"] = 1;
  let myHeaders = {
    "Content-Type": "application/json",
  };
  console.log(res);
  let myInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(res),
    mode: "cors",
    cache: "default",
  };
  fetch(fetchURL.path_justifs, myInit)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      console.log(result);
    })
    .catch((reason) => {
      console.log(reason);
    });
  document.querySelectorAll(".input-file").forEach((inputFile) => {
    inputFile.innerHTML = "";
  });
  document.querySelectorAll(".files-upload").forEach((inputEl) => {
    inputEl.value = "";
  });
  document.querySelectorAll(".file-size").forEach((fileSize) => {
    fileSize.classList.add("d-none");
  });
  document.querySelectorAll(".files-upload").forEach((el) => {
    files[el.name] = [];
  });
  setFormData({ ...formData, files });
};
